import { createSelector, createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../actions/api'

const initialState = {
    payments: { data: [], totalCount: 0 },
    paymentLookups: [],
    loading: false,
    error: null,
    refreshing: false,
}

const paymentSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {
        refreshRequested: (state, action) => {
            state.loading = true
            state.refreshing = true
            state.error = null
        },
        apiRequested: (state, action) => {
            state.loading = true
            state.error = null
        },
        apiRequestedFailed: (state, action) => {
            state.error = action.payload
            state.loading = false
            state.refreshing = false
        },
        getPayments: (state, action) => {
            state.payments = action.payload
            state.loading = false
            state.refreshing = false
        },
        getExistingPaymentById: (state, action) => {
            const index = state.payments.data.findIndex((payment) => payment.id === action.payload.id)
            if (index >= 0) state.payments[index] = action.payload
            else {
                state.payments.data.push(action.payload)
                state.payments.totalCount++
            }
            state.loading = false
        },
    },
})

const selectItems = (state) => state.data
const selectItemId = (state, itemId) => itemId
const selectItemById = createSelector([selectItems, selectItemId], (items, itemId) => {
    if (items) {
        const index = items.findIndex((item) => item.id === itemId)
        if (index >= 0) return { ...items[index] }
    }
    return {}
})
export { selectItemById }

export const { refreshRequested, apiRequested, apiRequestedFailed, getPayments, getExistingPaymentById } =
    paymentSlice.actions
export default paymentSlice.reducer

export const getPaymentList = (filter, refresh) => {
    let url = `/api/payment/history/list`
    return apiCallBegan({
        url: url,
        method: 'post',
        data: filter,
        onStart: refresh ? refreshRequested.type : apiRequested.type,
        onSuccess: getPayments.type,
        onError: apiRequestedFailed.type,
    })
}

export const getPaymentById = (filter) => {
    let url = `/api/payment/history/${filter.id}`
    return apiCallBegan({
        url: url,
        method: 'get',
        data: filter,
        onStart: apiRequested.type,
        onSuccess: getExistingPaymentById.type,
        onError: apiRequestedFailed.type,
    })
}
